import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../../constants/icons';
import { SVGIconType } from '../../../../constants/svgIcon';
import {
  getWebPageVariant,
  WebPageType,
} from '../../../../constants/webPageType';
import {
  SvgIcon,
  TextButton,
  TextButtonSize,
  TextButtonVariant,
} from '../../../Molecules';

import './EntryTemplate.css';

type EntryTemplateProps = {
  webPageType: WebPageType;
  onClickTryNow: () => void;
  onClickLogin: () => void;
  onClickRegister: () => void;
};

export const EntryTemplate = memo(
  ({
    webPageType,
    onClickTryNow,
    onClickLogin,
    onClickRegister,
  }: EntryTemplateProps) => {
    const { t } = useTranslation();
    const currentYears = new Date().getFullYear();

    return (
      <div className="entry">
        <div className="centered-container">
          <img className="logoTop" src={getWebPageVariant(webPageType).logo} />
          {webPageType === WebPageType.JOYAJOY ? (
            <>
              <img className="logoBot" src={Icons[IconType.JOYAJOYNameLogo]} />
              {/* <div className="quataBox">
                <p className="text-black-bold">{t('JOYAJOY Users')}</p>
                <div className="world-wide-quota">
                  <p className="text-normal">{t('Worldwide Quota:')}</p>
                  <SvgIcon name={SVGIconType.Region} className="regionIcon" />
                  <p className="text-black-bold">{t('33,230,000')}</p>
                </div>
                <p className="text-grey">
                  {t('Limited quota reserved for VIPs')}
                </p>
              </div> */}
            </>
          ) : (
            <p className="blue-text">{t('WEA Member Login')}</p>
          )}
          <div className="textButton1">
            <TextButton
              text={t('Try Now!')}
              size={TextButtonSize.Large}
              variant={TextButtonVariant.Orange}
              onClick={onClickTryNow}
            />
          </div>
          <div className="textButton2">
            <TextButton
              text={t('Login')}
              size={TextButtonSize.Large}
              variant={getWebPageVariant(webPageType).textButtonVariant}
              onClick={onClickLogin}
            />
          </div>
          <div className="textLink" onClick={onClickRegister}>
            <SvgIcon
              name={SVGIconType.Register}
              width={20}
              height={20}
              color={'#00A698'}
            />
            {t('Register a New Account')}
            <SvgIcon
              name={SVGIconType.Arrow}
              width={16}
              height={16}
              color={'#00A698'}
            />
          </div>
          <div className="text-copyright1">
            {t(getWebPageVariant(webPageType).copyrightText, {
              currentYear: currentYears,
            })}
          </div>
          <div className="text-copyright2">{t('All rights reserved.')}</div>
        </div>
      </div>
    );
  },
);
